import axios from 'axios'
import { IItem } from './Items'

const server = process.env.REACT_APP_SERVER_URL

export const setCatalogStatus = async (idItem: string, status: boolean) => {
  try {
      const response = await axios.patch<ISetCatalogResponseDTO>(
      `${server}/inventory/item/${idItem}/catalog`,
      {
        catalog: status,
      }
    )
    return {
      idItem: response.data.updatedItem.id,
      status: response.data.updatedItem.inCatalog
    }
  } catch (error) {
    throw error
  }
}

interface ISetCatalogResponseDTO {
  message: string
  status: number
  updatedItem: IItem
}
